<template>
    <div class="program-typeahead-container position-relative" style="z-index: 1000">
        <input 
            type="text" 
            v-model="programString" 
            name="name" 
            id="program-name" 
            placeholder="" 
            class="form-control"
            @keydown="debounceSearch"
            @blur="clearOnBlur"
            @input="$emit('input', programString)"
            @keydown.esc="clearSuggestions()"
            @keydown.down="navigateSuggestions('down')"
            @keydown.up="navigateSuggestions('up')"
            @keydown.enter.prevent="selectSuggestion(suggestions[focusedSuggestion])"
            @keydown.tab="selectSuggestion(suggestions[focusedSuggestion])"
        >
        <div class="position-absolute" style="width: 100%;">
            <ul class="loading list-group shadow-1" v-show="loading">
                <li class="list-group-item">loading…</li>
            </ul>
            <ul class="list-group list-group-sm shadow-1"
                v-show="showSuggestions">
                <li class="list-group-item csr-pointer"
                    v-for="(suggestion, idx) in suggestions"
                    :key="idx"
                    :class="{active: (idx == focusedSuggestion)}"
                    @click="selectSuggestion(suggestion)"
                >
                    {{suggestion.name}} - {{suggestion.state.name}}, {{suggestion.county.name}}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import debounce from 'lodash/debounce'

export default {
    props: {
        'modelValue': {
            required: true,
        }
    },
    data() {
        return {
            programString: '',
            suggestions: [],
            loading: false,
            focusedSuggestion: 0
        }
    },
    emits: ['update:modelValue'],
    computed: {
        showSuggestions: function() {
            try {
                return this.suggestions.length > 0 && !this.loading && this.programString.length > 2
            } catch (err) {
                throw new Error('ProgramTypeAhead::showSuggestions: '+err.message);
            }
        }
    },
    watch: {
        programString: function () {
            this.$emit('update:modelValue', this.programString);
        }
    },
    methods: {
        debounceSearch: debounce(function($evt) {
            const ignoreKeys = [ 9, 13, 27, 37,38,39,40]
            if (ignoreKeys.indexOf($evt.keyCode) > -1) {
                return;
            }
            this.suggestions = [];
            try {
                if (typeof this.programString !== 'undefined' && this.programString.length > 2) {
                    this.loading = true;
                    axios.get('/api/programs?name='+this.programString)
                        .then((response) => {
                            this.suggestions = response.data.data;
                            this.loading = false;
                        })
                        .catch((error) => {
                            this.loading = false;
                        })
                }
            } catch (err) {
                throw new Error('ProgramTypeAhead::debounceSearch: '+err.message);
            }
        }, 250),
        clearOnBlur: debounce(function (evt) {
            this.clearSuggestions();
        }, 250),
        selectSuggestion(suggestion) {
            if (typeof suggestion === 'undefined' || suggestion === null) {
                return;
            }
            this.suggestions = [];
            this.focusedSuggestion = 0;
            this.programString = suggestion.name;
            this.$emit('select', suggestion);
        },
        clearSuggestions() {
            this.suggestions = [];
            this.focusedSuggestion = 0;
        },
        navigateSuggestions(dir) {
            switch (dir) {
                case 'down':
                    if (this.focusedSuggestion === null) {
                        this.focusedSuggestion = 0;
                    }
                    try {
                        if (this.focusedSuggestion+1 < this.suggestions.length) {
                            this.focusedSuggestion++;
                        }
                    } catch (err) {
                        throw new Error('ProgramTypeAhead::navigateSuggestions: '+err.message);
                    }
                    break;
                case 'up':
                    if (this.focusedSuggestion > 0) {
                        this.focusedSuggestion--;
                    }
                    break;
                default:
                    break;
            }
        }
    },
    mounted() {
        this.programString = this.value;
    }
}
</script>

<style>

</style>
